export default "__VITE_ASSET__D_fZz6Yc__"